// extracted by mini-css-extract-plugin
export default {"wrap":"index-module_wrap_3zg3j","empty":"index-module_empty_amq-5"};